import * as dayjs from 'dayjs';
import { EXPIRATION_DAYS_THRESHOLD } from '../common/constants';
import { PerkSource } from './Perk';
export default class ESPerkMapper {
    constructor(impressionDescriptor) {
        this.impressionDescriptor = impressionDescriptor;
        // private language = currentLanguage();
        this.language = window.l.locale;
        this.localizedStringFields = [
            'title',
            'tagline',
            'description',
            'articleBody',
            'logo',
            'mobile',
            'banner',
            'thumbnail',
        ];
        this.localizedStringArrayFields = ['caption', 'tip', 'feature', 'keywords', 'image'];
        this.map = (data) => {
            const perk = data._source;
            this.mapLocalizedStringFields(perk);
            this.mapLocalizedStringArrayFields(perk);
            perk.source = PerkSource.Venngo;
            perk.isExpiring = perk.dateOfferEnd
                ? dayjs(perk.dateOfferEnd).subtract(EXPIRATION_DAYS_THRESHOLD, 'day').isBefore(new Date())
                : false;
            // TODO: (Rating) should come from API.
            // perk.rating = random(0, 5);
            perk.rating = 3;
            perk.locations = perk.location;
            console.log("DO I EVEN GET HERE");
            if (this.impressionDescriptor) {
                console.log("I EVER GET TRIGGERED");
                if (this.impressionDescriptor.templateId)
                    perk.templateId = this.impressionDescriptor.templateId;
                if (this.impressionDescriptor.query)
                    perk.searchQuery = this.impressionDescriptor.query;
            }
            delete perk.location;
            return perk;
        };
    }
    mapLocalizedStringFields(data) {
        for (const field of this.localizedStringFields) {
            data[field] = data[field][this.language];
        }
    }
    mapLocalizedStringArrayFields(data) {
        for (const field of this.localizedStringArrayFields) {
            data[field] = data[field][this.language];
        }
    }
}
